"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUpdateTask = void 0;
const core_ui_1 = require("@sierralabs/core-ui");
function useUpdateTask(id) {
    const _a = (0, core_ui_1.useApiPatch)(`tasks/${id}`), { patch } = _a, result = __rest(_a, ["patch"]);
    return Object.assign(Object.assign({}, result), { updateTask: patch });
}
exports.useUpdateTask = useUpdateTask;
//# sourceMappingURL=useUpdateTask.js.map